export const SKILL_CATEGORIES = ["Technical", "Physical", "Tactical", "Mental"];

export const IDP_FIELDS = [
  { key: "objective", label: "Overall objective", rows: 2 },
  { key: "strengths", label: "Strengths", rows: 3 },
  { key: "development_areas", label: "Areas to develop", rows: 3 },
  { key: "technical", label: "Technical", rows: 2 },
  { key: "physical", label: "Physical", rows: 2 },
  { key: "tactical", label: "Tactical", rows: 2 },
  { key: "mental", label: "Mental / mindset", rows: 2 },
  { key: "short_term_goals", label: "Short-term goals (4–6 weeks)", rows: 3 },
  { key: "long_term_goals", label: "Long-term goals (season)", rows: 3 },
];
